import { camelcaseKeys } from 'src/utils/camelize-keys';

import { AssignedVideo, Video } from './_types';

export const normalizeAssignedVideo = (resource): AssignedVideo => {
  return camelcaseKeys(resource, { deep: true }) as AssignedVideo;
};

export const normalizeVideo = (resource): Video => {
  return camelcaseKeys(resource, { deep: true }) as Video;
};
